import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    "type",
    "selected",
    "unselected",
    "replace"
  ]
  static values = { themeName: String, host: Boolean, currency: String, price: String, participants: Number, isEditing: Boolean }

  connect() {
    this.borderClass = this.element.getAttribute("data-border-class")
  }

  select(e) {
    mixpanel.track('Selected Delivery Type', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'deliveryType': e.target.closest("a").id,
      isEditing: this.isEditingValue
    });
  }
}
